export const IconFavicon = ({
  height = 24,
  width = 12,
}: {
  height?: number
  width?: number
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 76"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.6383 28.9809V55.9955C22.6383 61.2104 25.9574 64.288 31.5745 64.288C34.2128 64.288 37.0213 63.604 38.9787 62.4927V73.4353C35.6596 74.9741 31.0638 76 26.8085 76C14.8936 76 7.91489 69.3318 7.91489 57.8763V28.8954H0V18.7222H8.85106V0H23.5745V4.70191C23.5745 11.883 18.2128 16.9269 9.2766 18.5512V18.8076H40V28.9809H22.6383Z"
        fill="var(--mantine-color-white)"
      />
    </svg>
  )
}
